import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { AdminViewModel } from '../models/AdminViewModel';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    public baseurl = environment.apiUrl;
    private usersApi = "api/users";

    constructor(private http: HttpClient) { }

    GetUserDetail(userId) {
        const url = `${this.baseurl}${this.usersApi}/${userId}`;
        return this.http.get(url);
    }

    getUserPlan(userId) {
        const url = `${this.baseurl}${this.usersApi}/plan/${userId}`;
        return this.http.get(url);
    }

    GetuserList(data) {
        const url = this.baseurl + this.usersApi+ "?"+ this.GetUserListParameters(data);
        return this.http.get(url);
    }

    ChangeMemberShipStatus(userid, planid, isadministrator, upgradeId, expiryDate) {
        const url = this.baseurl + this.usersApi + '/ChangeMemberShipStatus' + '?userId=' + userid + '&planId=' + planid + '&IsAdministrator=' + isadministrator + '&UpgradeId=' + upgradeId + '&UpgradeExpiryDate=' + expiryDate;
        return this.http.get(url);   
      }

      GetRepresentativeList(){
        const url = this.baseurl + this.usersApi+ "/RepresentativeList";
        return this.http.get(url);
      }

    private GetUserListParameters(data:AdminViewModel){
        let url="";
        if(data.pageNo){
          url=url+`pageNo=${data.pageNo}`
        }
        if(data.pageSize){
          url=url+`&pageSize=${data.pageSize}`
        }
        if(data.searchText){
          url=url+`&searchText=${data.searchText}`
        }
        if(data.sort){
          url=url+`&sort=${data.sort}`
        }
        if(data.columnName){
          url=url+`&columnName=${data.columnName}`
        }
        if(data.regionId){
          url=url+`&regionId=${data.regionId}`
        }
        if(data.countryId){
          url=url+`&countryId=${data.countryId}`
        }
        if(data.shippinglineId){
          url=url+`&shippinglineId=${data.shippinglineId}`
        }
       return url;
    }
}
